import { IconButton } from '@mui/material';

export default function AccountPopover() {
  const logoUrl = window.REACT_APP_LOGO_URL;

  return (
    <IconButton
      disabled
      sx={{
        padding: 0,
        width: 140,
        height: 100,
      }}
    >
      <img src={logoUrl} alt="BNI Logo" />
    </IconButton>
  );
}
